import { ErrorHandler, Injectable } from '@angular/core';
import { EngieApmService } from 'platops-npm-apm';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    handleError(error) {
        EngieApmService.captureError(error);
    }
}